import { studioAIService } from '@/@admin/services';
import { MessageMarkerEntity } from '@/@admin/types/message-markers';
import { useQuery } from '@tanstack/react-query';

interface UseMessageMarkerOptions {
    conversationId: string;
    messageId: string;
    enabled?: boolean;
}

export function useMessageMarker({
    conversationId,
    messageId,
    enabled = true,
}: UseMessageMarkerOptions) {
    return useQuery<MessageMarkerEntity | null>({
        queryKey: ['message-markers', 'by-message', conversationId, messageId],
        queryFn: () => studioAIService.getMessageMarkerByMessageId(conversationId, messageId),
        enabled,
        staleTime: 30000, // 30 seconds
    });
}
